import { AnyAri } from '@atlassian/ari/any-ari';

export type RecentItemAnalyticsAttributes = {
	is3pLink: boolean;
	product?: string;
	contentType?: string;
	eventType?: string;
};

/**
 * Recent item click attributes that tell Confluence and third-party (3P) items apart. Both navs send
 * them, so the values are the same in either. Any other item gets its product and content type from
 * its ARI, e.g. "ari:third-party:google.google-drive::document/1" is a "google-drive" "document".
 */
export const getRecentItemAnalyticsAttributes = (
	objectId: string | null | undefined,
	eventType: string | null | undefined,
): RecentItemAnalyticsAttributes => {
	// Lowercased: the Recent transform uppercases Confluence event types, 3P ones arrive raw from AGG
	const lowerCaseEventType = eventType?.toLowerCase();

	// "Created by me" items have no object ID, but come from a Confluence-only search
	if (!objectId || objectId.startsWith('ari:cloud:confluence:')) {
		return { is3pLink: false, product: 'confluence', eventType: lowerCaseEventType };
	}

	try {
		const { resourceOwner, resourceType } = AnyAri.parse(objectId);
		return {
			is3pLink: true,
			product: resourceOwner.split('.').pop(),
			contentType: resourceType,
			eventType: lowerCaseEventType,
		};
	} catch {
		return { is3pLink: true, eventType: lowerCaseEventType };
	}
};
